import Model from 'src/app/common/model';

export default class TransactionTypeModel extends Model {
  transaction_type: string;
  description?: string;

  constructor() {
    super();
  }
}
